import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { SeoService } from './services/seo-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'MSL Trade';
  ActiveNav = ""
  constructor(private router: Router, private route: ActivatedRoute, private ObjSEOServices: SeoService) { }

  ngOnInit() {
    
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.route),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    )
      .subscribe((event) => {
        console.log(event['title'])
        this.ObjSEOServices.updateTitle(event['title']);
        this.ObjSEOServices.updateOgUrl(event['ogUrl']);
        //Updating Description tag dynamically with title
        this.ObjSEOServices.updateDescription(event['title'] + event['description'])
      });
  }

  GotoHome() {
    this.router.navigateByUrl('home').then((res) => {
      if (res) {
        window.location.reload();
        // this.router.onSameUrlNavigation = 'reload';
        // this.router.navigated = true;
      }
    }, (error) => {
      console.log(error);
    })
  }

  OpenGovernace() {
    if (document.getElementById('Governace').style.display == 'none') {
      document.getElementById('Governace').style.display = 'block';
    } else {
      document.getElementById('Governace').style.display = 'none';
    }
  }

  OpenService(){
    if (document.getElementById('services').style.display == 'none') {
      document.getElementById('services').style.display = 'block';
    } else {
      document.getElementById('services').style.display = 'none';
    }
  }

  OpenAboutUs() {
    if (document.getElementById('AboutUs').style.display == 'none') {
      document.getElementById('AboutUs').style.display = 'block';
    } else {
      document.getElementById('AboutUs').style.display = 'none';
    }
  }

  OpenInvestorInfo() {
    if (document.getElementById('InvestorInfo').style.display == 'none') {
      document.getElementById('InvestorInfo').style.display = 'block';
    } else {
      document.getElementById('InvestorInfo').style.display = 'none';
    }
  }

  OpenEducationCenter() {
    if (document.getElementById('EducationCenter').style.display == 'none') {
      document.getElementById('EducationCenter').style.display = 'block';
    } else {
      document.getElementById('EducationCenter').style.display = 'none';
    }
  }

  GoToRegSECP() {
    this.router.navigateByUrl('registrationsecp').then((res) => {
      if (res) {
        window.location.reload();
      }
    }, (error) => {
      console.log(error);
    })
  }

  // GoToRegPMEXSECP() {
  //   this.router.navigateByUrl('registrationpmexsecp').then((res) => {
  //     if (res) {
  //       window.location.reload();
  //     }
  //   }, (error) => {
  //     console.log(error);
  //   })
  // }

  GoToRating() {
    this.router.navigateByUrl('rating').then((res) => {
      if (res) {
        window.location.reload();
      }
    }, (error) => {
      console.log(error);
    })
  }
  NavActive(param)
  {
    this.ActiveNav = param
  }

}
